export const ErrorStatus = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  CREDIT_CHECK_FAILED: 'CREDIT_CHECK_FAILED',
  BUDGET_EXCEEDED: 'BUDGET_EXCEEDED',
  CANNOT_FETCH_REACH_FORECAST: 'CANNOT_FETCH_REACH_FORECAST',
  REACH_API_UNAVAILABLE: 'REACH_API_UNAVAILABLE',
} as const;
